module.exports = __webpack_public_path__ + "static/img/task-add-icon.44800a9a.svg";